import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getPaymentsExport = api.injectEndpoints({
  endpoints: builder => ({
    getPaymentsExport: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/payments`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{message: string}>;

export const {useLazyGetPaymentsExportQuery} = getPaymentsExport;
